import React from "react";
import { makeStyles } from "@mui/styles";
import { FontSize } from "src/const/font";
import { colors } from "src/colors/colors";

const useStyles = makeStyles((theme) => {
  return {
    styleDefault: {
      fontSize: FontSize.sub.default,
      fontWeight: 400,
      lineHeight: FontSize.sub.default,
      color: colors.text.blue2,
      [theme.breakpoints.down("md")]: {
        fontSize: FontSize.sub.s2,
        fontWeight: 400,
      },
    },
  };
});
interface PropsTextTitleI {
  style?: React.CSSProperties;
  children: string | any;
  className?: string;
}

const TextSub = (props: PropsTextTitleI) => {
  const { style, children, className } = props;
  const classes = useStyles();
  //! Render
  return (
    <>
      <p
        className={`${classes.styleDefault} ${className}`}
        style={{ ...style }}
      >
        {children}
      </p>
    </>
  );
};
export default TextSub;